import { Pipe } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { PrefixedTranslatePipe } from './prefixed-translate.pipe'

@Pipe({
  name: 'recipientType',
  pure: false
})
export class RecipientTypePipe extends PrefixedTranslatePipe {

  constructor (translatePipe: TranslatePipe) {
    super(translatePipe, 'RECIPIENT_TYPES.')
  }
}
